import type { AxiosRequestConfig } from "axios";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { ILoanOfficer } from "@/types/users-loan-officers";
import { BaseRepository } from "../BaseRepository";
import type { LoanOfficersService } from "./service";
import type {
  IDeleteLoanOfficerRequest,
  IGetLoanOfficerProfileByUserIdRequest,
  IGetLoanOfficersRequest,
  IUpdateLoanOfficerRequest,
} from "./types";

export class LoanOfficersRepository extends BaseRepository {
  constructor(
    private readonly service: LoanOfficersService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetLoanOfficersRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<ILoanOfficer>> {
    const response = await this.handleRequest(this.service.getAll, p, c);
    return response.data;
  }

  async deleteLoanOfficer(
    p: IDeleteLoanOfficerRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    await this.handleRequest(this.service.deleteLoanOfficer, p, c);
  }

  async getProfileByUserId(
    p: IGetLoanOfficerProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<ILoanOfficer> {
    const response = await this.handleRequest(
      this.service.getProfileByUserId,
      p,
      c,
    );
    return response.data;
  }

  async updateProfile(
    p: IUpdateLoanOfficerRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    await this.handleRequest(this.service.updateProfile, p, c);
  }
}
